import React from "react";
import "./BreakTime.css";

const BreakTime = ({ breakTime }) => {
  return (
    <div>
      <div className="break-time p-3 d-flex justify-content-between mt-3">
        <span className="fw-bold">Break time</span>
        <span className="me-4 text-secondary">{breakTime} seconds</span>
      </div>
    </div>
  );
};

export default BreakTime;
